export const getChatSessionTimeSeries = '/admin/v1/analytics/chatSessionsTimeSeries'
export const getUserEngagementStats = '/admin/v1/analytics/userEngagementStats'
export const getUserRetention = '/admin/v1/analytics/retentionCohorts'